import { createContext, useContext, useEffect, useState } from "react";
import api, { setTokens } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const authenticate = async (path, body) => {
    const { data } = await api.post(path, body);
    setTokens(data.access_token, data.refresh_token);
    setUser(data.user);
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setTokens(null, null);
    setUser(false);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        login: (b) => authenticate("/auth/login", b),
        register: (b) => authenticate("/auth/register", b),
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
